<template lang="html">

  <div class="datos-tarifa container" v-if="!!tarifa">

    <div :class="['contenedor-pagos', 'container ais', 'row-center']">
      <div class="contenedor-grafica-horario">
        <div class="botones row-center" v-if="how == 'DHA' || how == 'FULL'">
          <button :active="activo == 'diario'" @click="activo = 'diario'" class="btn -skull-orange -small">{{
            $t('aDiario') }}</button>
          <button :active="activo == 'fines'" @click="activo = 'fines'" class="btn -skull-orange -small">{{
            $t('FinesDeSemana') }}</button>
        </div>
        <img src="/static/img/grafica-horario-20.svg"
          v-if="activo == 'diario' && type !== 'tranquilidad' && type !== 'precioCoste' && type !== 'CEprecioCoste'">
        <img src="/static/img/grafica-horario-20-finde.svg"
          v-if="activo == 'fines' && type !== 'tranquilidad' && type !== 'precioCoste' && type !== 'CEprecioCoste'">
        <img src="/static/img/grafica-horario-20-todo.svg"
          v-if="type == 'tranquilidad' && type !== 'precioCoste' && type !== 'CEprecioCoste'">
      </div>

      <article :class="['pago-el']" class="column-between">

        <img src="/static/img/sello.svg" class="sello-recomendada" v-if="type == 'solar'">
        <!-- <img src="/static/img/sello_precios.svg" class="sello-precio"> -->
        <div v-if="type !== 'precioCoste' && type !== 'CEprecioCoste'" style="min-width: 100%;">


          <div>
            <h3 class="-orange">{{ $t('precioFijoTodoElAno') }}</h3>
            <h4 class="-dark-orange">{{ $t(`titlesBoxPrecios['${type}']`) }}</h4>
          </div>

          <div class="contenedor-toggle">
            <input type="checkbox" :id="'impuestos' + how + type" v-model="impuestos">
            <label :for="'impuestos' + how + type">{{ $t('verPreciosConImpuestosYDescuentos') }}</label>
          </div>

          <div>
            <div class="row-center data">
              <div v-if="!!precios">
                <h5 class="energia">Energía</h5>
                <h2 class="precio -valle" v-if="!!tarifa.p3 && how == 'DHA' || how == 'FULL'">
                  <strong v-if="how == 'DHA' || how == 'FULL'" v-html="how == 'DHA' ? $t('valle') : 'P1'"
                    :class="how == 'FULL' ? 'mw-70' : ''"> </strong>
                  {{ ((how == 'DHA' ? tarifa.p3 : tarifa.p1) * ivaMultiplier) | comma }}
                  <i> €/kWh</i>
                </h2>
                <h2 class="precio -llano" v-if="!!tarifa.p2">
                  <strong v-if="how == 'DHA' || how == 'FULL'" v-html="how == 'DHA' ? $t('llano') : 'P2'"
                    :class="how == 'FULL' ? 'mw-70' : ''"></strong>
                   {{ (tarifa.p2 * ivaMultiplier) | comma }}
                  <i> €/kWh</i>
                </h2>
                <h2 class="precio -punta" v-if="!!tarifa.p1 && how == 'DHA' || how == 'FULL'">
                  <strong v-if="how == 'DHA' || how == 'FULL'" v-html="how == 'DHA' ? $t('punta') : 'P3'"
                    :class="how == 'FULL' ? 'mw-70' : ''"></strong>
                   {{ ((how == 'DHA' ? tarifa.p1 : tarifa.p3)  * ivaMultiplier) | comma }}
                  <i> €/kWh</i>
                </h2>
                <h2 class="precio -p4" v-if="!!tarifa.p4 && how == 'FULL'">
                  <strong v-html="'P4'" style="min-width: 70px;">
                  </strong>
                   {{ (tarifa.p4 * ivaMultiplier) | comma }}
                  <i> €/kWh</i>
                </h2>
                <h2 class="precio -p5" v-if="!!tarifa.p5 && how == 'FULL'">
                  <strong v-html="'P5'" style="min-width: 70px;">
                  </strong>
                   {{ (tarifa.p5 * ivaMultiplier) | comma }}
                  <i> €/kWh</i>
                </h2>
                <h2 class="precio -p6" v-if="!!tarifa.p6 && how == 'FULL'">
                  <strong v-html="'P6'" style="min-width: 70px;">
                  </strong>
                  {{ (tarifa.p6 * ivaMultiplier) | comma }}
                  <i> €/kWh</i>
                </h2>
              </div>
              <div class="container-potencia">
                <h5 class="energia">{{ $t('potencia') }}</h5>
                <h2 class="precio -valle" v-if="!!tarifa.p3 && how == 'DHA' || how == 'FULL' || type == 'tranquilidad'"
                  :tarifa="type">
                  <strong v-if="how == 'DHA' || how == 'FULL' || type == 'tranquilidad'"
                    v-html="how == 'DHA' || type == 'tranquilidad' ? $t('valle') : 'P1'"
                    :class="how == 'FULL' ? 'mw-70' : ''">
                  </strong>
                  {{ ((how == 'DHA' ? tarifa.po3 : tarifa.po1) * ivaMultiplier) | comma }}
                  <i> €/kW día</i>
                </h2>
                <h2 class="precio -llano" v-if="!!tarifa.p2 && type !== 'tranquilidad'">
                  <strong v-if="how == 'DHA' || how == 'FULL'" v-html="how == 'DHA' ? $t('llano') : 'P2'"
                    :class="how == 'FULL' ? 'mw-70' : ''">
                  </strong>
                  <template v-if="how == 'DHA'">
                    <br>
                  </template>
                  <template v-else>
                    {{ (tarifa.po2 * ivaMultiplier) | comma }}
                    <i> €/kW día</i>
                  </template>

                </h2>
                <h2 class="precio -punta" v-if="!!tarifa.p1 && how == 'DHA' || how == 'FULL' || type == 'tranquilidad'"
                  :tarifa="type">
                  <strong v-if="how == 'DHA' || how == 'FULL' || type == 'tranquilidad'"
                    v-html="how == 'DHA' || type == 'tranquilidad' ? $t('punta') : 'P3'"
                    :class="how == 'FULL' ? 'mw-70' : ''">
                  </strong>
                  {{ ((how == 'DHA' ? tarifa.po1 : tarifa.po3) * ivaMultiplier) | comma }}
                  <i> €/kW día</i>
                </h2>
                <h2 class="precio -p4" v-if="!!tarifa.po4 && how == 'FULL'">
                  <strong v-html="'P4'" class="mw-70">
                  </strong>
                  {{ (tarifa.po4 * ivaMultiplier) | comma }}
                  <i> €/kW día</i>
                </h2>
                <h2 class="precio -p5" v-if="!!tarifa.po5 && how == 'FULL'">
                  <strong v-html="'P5'" class="mw-70">
                  </strong>
                  {{ (tarifa.po5 * ivaMultiplier) | comma }}
                  <i> €/kW día</i>
                </h2>
                <h2 class="precio -p6" v-if="!!tarifa.po6 && how == 'FULL'">
                  <strong v-html="'P6'" class="mw-70">
                  </strong>
                  {{ (tarifa.po6 * ivaMultiplier) | comma }}
                  <i> €/kW día</i>
                </h2>
              </div>
            </div>
<!--             <p class="nota-precio -xs" v-if="how !== 'FULL'" @click="showprecios = true"><span>{{ $t('preciosMostrados')
                }}
                <a>{{ $t('saberMas') }}</a></span></p> -->
                <p class="nota-precio -xs"></p>
          </div>


        </div>
        <div v-if="type == 'precioCoste' || type == 'CEprecioCoste'" style="min-width: 100%;">
          <h3 class="-orange">{{ $t('precioCoste') }}</h3>
          <h4 class="-dark-orange">{{ $t(`titlesBoxPrecios['${type}']`) }}</h4>
          <h4>{{ $t('tarifaPrecioCoste') }}</h4>
          <div class="info-coste">
            <h4 class="precio-coste" v-if="!!precios">
              <strong>{{ precios.cuotaluz | comma }}</strong><span>€ / mes</span>
            </h4>
            <h5 v-if="type == 'precioCoste'" class=" cuota-fija">{{ $t('tarifasLuz.intro.cuotaFija') }}</h5>
          </div>
          <h2 v-if="type == 'CEprecioCoste'" class="precio">Siempre a coste oficial</h2>
          <p v-if="type == 'CEprecioCoste'" class="nota-precio">Precio oficial de la energía +0,01€ Kw/h<br>Varía cada
            mes.</p>
          <p v-else class="nota-precio -xs">
            <span v-html="$t('precioCosteSubText')"></span>
          </p>
        </div>
        <router-link :to="$t('enlaces.inergizate') + '?suministro=luz&tarifa=' + type + '&tipo=' + priceType" title="Contrata"
          class="btn -degree" :style="how === 'FULL' ? 'margin-top: 30px;' : ''">{{ $t('elijoEstaOpcion')
          }}</router-link>

      </article>
      <!--       <article :class="['pago-el', (how == 'DHA') ? '-small' : '']" v-if="how == 'DHA' && type != 'solar'">
        <div>
          <h3 class="-dark-orange">{{ $t('precioDeCoste') }}</h3>
          <h4 class="-orange">{{ $t('loQueCuesta') }}</h4>
        </div>

        <div>

          <template>
            <h2 class="precio">
              <template v-if="type == 'coche_electrico'"> {{ $t('tuTarifaMovilidad') }}</template>
              <template v-else> {{ $t('tuTarifaLuz') }}</template>
              <br>
              {{ $t('aPrecioDeCoste') }}
            </h2>
            <h4 class="precio-big" v-if="!!precios">
              <strong>{{ precios.cuotaluz | comma }}</strong><span>€ / mes</span>
            </h4>

          </template>


          <p class="nota-precio" v-if="!type.includes('dos-uno')" v-html="$t('preciosoficialSinMargen')"></p>

          <p class="nota-precio" v-if="type.includes('dos-uno')" v-html="$t('preciosoficial0energia')"></p>



        </div>


        <router-link :to="$t('enlaces.inergizate') + '?suministro=luz&tarifa=' + type" title="Contrata"
          class="btn -degree">{{ $t('elijoEstaOpcion') }}</router-link>


      </article> -->

      <!-- <p class="potencia"><strong>Potencia</strong> siempre a <strong v-if="!!tarifa.po1_day">{{tarifa.po1_day}}</strong> <strong v-if="!!!tarifa.po1_day & !!tarifa.po2_day">{{tarifa.po2_day}}</strong>€/Kw día</p> -->

      <div class="contenedor-ventajas container row-center">

        <h4 class="ventaja" v-if="type == 'precioCoste' || type == 'CEprecioCoste'">
          <figure><img src="/static/img/tick.svg" alt=""></figure>
          Potencia a precio de coste
          <a class="viewmore" @click="showpopuppotencia = !showpopuppotencia"><span>?</span></a>
        </h4>

        <h4 class="ventaja">
          <figure><img src="/static/img/tick.svg" alt=""></figure>
          Alta online sin papeleos
        </h4>
        <!--         <h4 class="ventaja">
          <figure><img src="/static/img/tick.svg" alt=""></figure>
          Sin permanencia
        </h4>
        <h4 class="ventaja" v-if="!!precios & type.includes('dos-uno')">
          <figure><img src="/static/img/tick.svg" alt=""></figure>
          {{ precios.cuotaluz | comma }}€ al mes + tu consumo de luz
        </h4>

        <h4 class="ventaja" v-if="!!precios & !type.includes('dos-uno')">
          <figure><img src="/static/img/tick.svg" alt=""></figure>
          {{ precios.cuotaluz | comma }}€ al mes + luz a precio de coste
        </h4> -->

        <h4 class="ventaja" v-if="!!precios && type == 'precioCoste' || type == 'CEprecioCoste'">
          <figure><img src="/static/img/tick.svg" alt=""></figure>
          {{ precios.cuotaluz | comma }}€ al mes + luz a precio de coste
        </h4>
      </div>

    </div>

    <grafica-precio-coste @close="showgraficacoste = false" v-if="showgraficacoste" :type="type">
    </grafica-precio-coste>

    <div class="contenedor-popup row-center" v-if="showpopuppotencia">
      <div class="info-popup">
        <a @click="showpopuppotencia = false" class="cerrar">✕</a>
        <h4>{{ $t('preciosPotencia') }}</h4>
        <p>P1 - {{ tarifa.po1 | comma }}€/KW mes</p>
        <p>P3 - {{ tarifa.po3 | comma }}€/KW mes</p>
      </div>
    </div>


    <div class="contenedor-popup row-center" v-if="showprecios">
      <div class="info-popup">
        <a @click="showprecios = false" class="cerrar">✕</a>
        <p v-html="$t('ivaAplicado')"></p>
      </div>
    </div>


  </div>
</template>

<script lang="js">

import { mapGetters } from 'vuex';

import graficaPrecioCoste from '@/components/parts/grafica-precio-coste';

export default {
  name: 'selector-precio-tarifa',
  props: ['how', 'type', 'priceType'],
  data() {
    return {
      showgraficacoste: false,
      showpopuppotencia: false,
      showprecios: false,
      tipotarifa: '',
      activo: 'diario',
      impuestos: false
    }
  },
  computed: {
    ...mapGetters({
      precios: 'getPrecios',
      horario: 'gethorario'
    }),
    ivaMultiplier() {
      return this.impuestos ? 1.27186363 : 1;
    },
    tarifa() {
      if (!!this.precios) {
        let tarifa = this.precios.tarifas_luz[this.type];
        
        if (this.type == 'precioCoste') {
          tarifa = this.precios.tarifas_luz['clasica'];
        }

        if (this.type == 'CEprecioCoste') {
          tarifa = this.precios.tarifas_luz['cocheElectrico'];
        }
        
        return this.priceType == 'fixed' ? tarifa.fixed : tarifa.index;
      }
    }
  },
  components: {
    graficaPrecioCoste
  },
  filters: {
    potenciadia(value) {
      if (!!value) {
        value = value.replace(',', '.');
        value = Number(value) / 30;
        return String(value).substring(0, 6).replace('.', ',');
      }
    }
  }
}
</script>

<style scoped lang="scss">
.potencia {
  margin-top: 5px;
  width: 100%;
  display: inline-block;
  text-align: left;

  strong {
    font-weight: 800;
  }
}

.info-coste .precio-coste {
  font-weight: 400;
  font-size: 36px;
  line-height: 90px;
  color: #F6A910;
  margin-bottom: 0px !important;
}

.info-coste .precio-coste strong {
  font-size: 120px;
  font-weight: 800;

  @media screen and (max-width: 768px) {
    font-size: 65px;
    font-weight: 800;
  }
}

.info-coste .cuota-fija {
  text-transform: uppercase;
  color: #5e639f;
  font-weight: 400;
  font-size: 20px;
  line-height: .8em;
  margin-bottom: 10px;
}

.viewmore {
  right: 10px;
  left: auto;
  width: auto;


}




@media screen and (max-width: 520px) {
  .potencia {
    margin-top: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/parts/selector-precio-tarifa.vue